import styled from 'styled-components';

export const CloseBackGround = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
  background: #00000059;
`;

export const Container = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  top: 0px;
  z-index: 100;
  background: ${(props) => props.theme.serviceDeskMainBackground};
  border-radius: 4px;
  box-shadow: 0px 0.15px 0.45px 0px rgba(0, 0, 0, 0.11),
    0px 0.8px 1.8px 0px rgba(0, 0, 0, 0.13);
`;

export const InnerContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ScrollableContainer = styled.div`
  overflow-y: auto;
  height: 100%;
  padding-bottom: 10px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  padding: 16px;
`;

export const Title = styled.h1`
  text-align: center;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.43px;
`;

export const SubTitle = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: ${(props) => props.theme.serviceDeskColorButtonRest};
`;

export const SortOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

export const SortOptionSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const RadioButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 6px;
`;

export const SortOptionTitle = styled.h2`
  font-size: 14px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: ${(props) => props.theme.serviceDeskTextColorTertiary};
`;

export const SortFooter = styled.div`
  position: sticky;
  bottom: 0;
  display: grid;
  grid-template-columns: max-content 1fr max-content 12px max-content;
  grid-template-rows: auto;
  grid-template-areas: 'clearAllBtn . discardBtn . sortBtn';
  align-items: center;
  padding: 16px 20px 30px 20px;
  box-shadow: 0px -1.2px 3.6px 0px rgba(0, 0, 0, 0.11);
`;
